import { useRecoilValue } from "recoil";
import { trackActionCallback } from "./trackActionCallback";

export const useTrackAction = () => useRecoilValue(trackActionCallback);
